import axios from "../axiosInstance";
import {
  CreateEmailNotificationRequest,
  CreateEmailNotificationResponse,
} from "./types";

export const createEmailNotification = async (
  payload: CreateEmailNotificationRequest,
): Promise<CreateEmailNotificationResponse> => {
  const response = await axios.post<CreateEmailNotificationResponse>(
    "/api/private/email-notifications",
    payload,
  );
  return response.data;
};
